import { createVNode, render } from 'vue';
import BpLoadingOverlay from './BpLoadingOverlay.vue';

const ativos = new Map();

const FULLSCREEN = Symbol('fullscreen');

function resolveAlvo(alvo) {
  if (!alvo) return null;
  if (typeof alvo === 'string') return document.querySelector(alvo);
  if (alvo instanceof Element) return alvo;
  if (alvo.$el instanceof Element) return alvo.$el;
  return null;
}

function desmontar(chave) {
  const entrada = ativos.get(chave);
  if (!entrada) return;

  render(null, entrada.host);
  entrada.host.remove();

  if (entrada.posicaoAnterior !== null) {
    entrada.container.style.position = entrada.posicaoAnterior;
  }

  ativos.delete(chave);
}

function loading(opcoes = {}) {
  const { container, text = '', color = '', scale = 1, background = '' } =
    opcoes || {};

  const alvo = resolveAlvo(container);
  const fullscreen = !alvo;
  const chave = fullscreen ? FULLSCREEN : alvo;

  if (ativos.has(chave)) desmontar(chave);

  const hospedeiro = fullscreen ? document.body : alvo;

  let posicaoAnterior = null;
  if (!fullscreen && getComputedStyle(hospedeiro).position === 'static') {
    posicaoAnterior = hospedeiro.style.position;
    hospedeiro.style.position = 'relative';
  }

  const host = document.createElement('div');
  hospedeiro.appendChild(host);

  render(
    createVNode(BpLoadingOverlay, { fullscreen, text, color, scale, background }),
    host,
  );

  ativos.set(chave, { host, container: hospedeiro, posicaoAnterior });
}

loading.close = (alvo) => {
  if (!alvo) {
    desmontar(FULLSCREEN);
    return;
  }
  const el = resolveAlvo(alvo);
  if (el) desmontar(el);
};

loading.closeAll = () => {
  Array.from(ativos.keys()).forEach(desmontar);
};

export default loading;

export const BpLoadingPlugin = {
  install(app) {
    app.config.globalProperties.$bpLoading = loading;
  },
};
